import { ArrowLeftIcon, MagnifyingGlassIcon, PlusCircleIcon, ArrowRightIcon, CheckCircleIcon, ExclamationCircleIcon } from '@heroicons/react/24/outline'
import { useState, useEffect, useRef } from "react";
import { Formik, Form, Field, useFormik, useFormikContext } from 'formik'
import { object, string} from 'yup';
import { useNavigate } from 'react-router';

import { Label } from "./Label" // Custom label
import AdmisionEdicion from './AdmisionEdicion';
import AdmisionesGridSoli from "./AdmisionesGridSoli" // Grid despliega cuotas
import AdminDatosNuevo from "./AdmisionesDatosNuevo" // Form admision nueva
import { fetchApi, handleDpiBlur } from "./helpers" // Consumir api
import WarningModal from "../components-modals/WarningModal" // Modal mensajes para el usuario
import { useTodosPlanes } from './custom-hooks'
import { formatearFechaDiagonalesDDMMYY, formatearFechaASinDiagonales } from '../tools/ConversionFechas';


//import {Animate,initTE,} from "tw-elements";

const AdminStep2 = ({ setPasosSidebar, esNuevo, setEsNuevo, datosInscripcionStep1, setDatosPasos, sendPlanes, handleSeleccionado, obtenerCarnet, handleDatosFormNuevo, datosFormNuevo, datosInscripcion, obtenerDatosInscripcion, handleIdSeleccionado, haySolicitudSeleccionada, idSeleccionado, Validar, obtenerCarnetEstudiante, parametros, idsRuta, setIdsRuta, setRutaAlt, rutaAlt, setDatosGradoParametro, setEstadoAlumno, ...props }) => {

    const navigate = useNavigate()
    const [parametrosRuta, setParametrosRuta] = useState(parametros)
    const buscarRef = useRef(null);
    const [bloqueador, setBloqueador] = useState(0)
    const [carnetValidado, setCarnetValidado] = useState('')
    const [dataFromParams, setDataFromParams] = useState({})


    const [todosPlanes, handleTodosPlanes] = useTodosPlanes(props.url, props.headers); // Todos los Planes
    const [loading, setLoading] = useState(false)
    const [botonProveniente, setBotonProveniente] = useState('')

    //const [open,    setOpen]    = useState(false) //para admision modal
    const [isGrid, setIsGrid] = useState(0)
    const [data, setData] = useState({})


    const [datosSolicitud, setDatosSolicitud] = useState({})
    const [inscripcionValues, setInscripcionValues] = useState([])
    const [dpiEncargado, setDpiEncargado] = useState('')
    const [valorEstadoSolicitud, setValorEstadoSolicitud] = useState('')

    const [contadorDPI, setContadorDPI] = useState(0)
    const [fechaSinFormato, setFechaSinFormato] = useState()
    const [gridSolicitud, setGridSolicitud] = useState(2)
    //Manejo de errores


    const [modal, setModal] = useState({
        show: false,
        msg: '',
        ok: false,
    })
    const handleEstadoSolicitud = (valor) => {
        setValorEstadoSolicitud(valor)
    }



    const consultarPlanes = async () => {
        await handleTodosPlanes()
    };

    const initialValues = {

        "IdSolicitud": "",
        "TipoIns": "N",
        "IdSede": props.IdSede,
        "Dpi": props.datosPasos.Dpi,
        "IdGrado": props.IdGrado,
        "IdPlan": datosInscripcion.Plan,
        "IdCarrera": datosInscripcion.Carrera,
        "Email": props.Email,
        "Nombres": '',
        "Apellidos": "",
        "FechaNace": "",
        "ApellidosE": "",
        "FechaNaceE": "",
        "Genero": '',
        "fechanacimiento": "",
        "Cel": "",
        "ColAnterior": "",
        "E_Edad": '',
        "E_Sexo": '',
        "E_Telcasa": '',
        "E_DPI": '',
        "E_EstadoCiv": '',
        "FechaNac": "",
        "E_Ocupa": '',
        "E_Direcc": '',
        "E_Depto": '',
        "E_Muni": '',
        "EmailE": '',
        "E_EmailE": '',
        "E_Nombres": '',
        "E_Apellidos": '',
        "Nacionalidad": '',
        "FotoN": '',

        "idemp": '',
        "Origen": "Pagina Administrativo",
        "IdEmp": props.IdEmp,

        "IpHost": "131.107.1.235",
        "HostName": "DEV1",
        "NombreBrowser": "Windows",
        "Diplomado": "",
        "OS": "Windows"
    }

    const imageSchema = (maxKb = 100, formats = ['image/jpeg', 'image/jpg']) => {
        return string().nullable().notRequired()
            .test({
                name: 'MAX_SIZE',
                test: (value) => {
                    const imgBlob = new Blob([value])
                    if (!value || imgBlob.size < (maxKb * 1024)) {
                        return true
                    } else {
                        return false
                    }
                },
                message: `La imagen debe ser menor de ${maxKb}kb`
            })
            .test({
                name: 'IS_FORMAT',
                test: (value) => {
                    const type = value?.split(';')[0].split(':')[1]
                    if (!value || formats.includes(type)) {
                        return true
                    } else {
                        return false
                    }
                },
                message: `La imagen debe ser formato ${formats.map(x => x.split('image/').at(-1)).join(', ')}`
            })
    }
    const validationSchema = object({
        "FechaNace": (isGrid === 2 ?   string().required('Dato obligatorio') : ''),
        "ColAnterior": (isGrid === 2 ? string().required('Dato obligatorio') : ''),
        "Nombres": (isGrid === 2 ?     string().required('Dato obligatorio') : ''),
        "Apellidos": (isGrid === 2 ?   string().required('Dato obligatorio') : ''),
        "NombresE": (isGrid === 2 ?    string().required('Dato obligatorio') : ''),
        "ApellidosE": (isGrid === 2 ?  string().required('Dato obligatorio') : ''),
        "Genero": (isGrid === 2 ?      string().required('Dato obligatorio') : ''),
        "FechaNac": (isGrid === 3 ?    string().required('Dato obligatorio') : ''),
        "E_Nombres": (isGrid === 3 ?   string().required('Dato obligatorio') : ''),
        "E_Apellidos": (isGrid === 3 ? string().required('Dato obligatorio') : ''),
        "Cel":string().min(8, 'El número no debe tener menos de 8 dígitos').max(8, 'El número no debe tener más de 8 dígitos').required('Dato obligatorio'),
        "E_Edad": (isGrid === 3 ? valorEstadoSolicitud === 'Prospecto' || valorEstadoSolicitud === 'Pendiente de pago' ?      string().min(2, 'Edad no válida').max(2, 'Edad no válida') : string().required('Obligatorio') : ''),
        "E_Sexo": (isGrid === 3 ? valorEstadoSolicitud === 'Prospecto' || valorEstadoSolicitud === 'Pendiente de pago' ? '' : string().required('Obligatorio') : ''),
        "E_Telcasa": (isGrid === 3 ? valorEstadoSolicitud === 'Prospecto' || valorEstadoSolicitud === 'Pendiente de pago' ?   string().min(8, "no debe ser menor a 8 digitos").max(8, "no debe ser mayor a 8 digitos") : string().required('Obligatorio')
            .test({
                name: "CELLPHONE_IS_VALID",
                test: (value) => {
                    const regex = /^[0-9]{8}$/
                    return regex.test(value)
                },
                message: "Número de télefono no válido"
            }) : ''),
        "E_DPI": (isGrid === 3 ? valorEstadoSolicitud === 'Prospecto' || valorEstadoSolicitud === 'Pendiente de pago' ? string().min(13, "no debe ser menor a 13 digitos").max(13, "no debe ser mayor a 13 digitos") : string().required('Obligatorio') : ''),
        "E_EstadoCiv": (isGrid === 3 ? valorEstadoSolicitud === 'Prospecto' || valorEstadoSolicitud === 'Pendiente de pago' ? '' :  string().required('Obligatorio') : ''),
        "E_Ocupa": (isGrid === 3 ? valorEstadoSolicitud === 'Prospecto' || valorEstadoSolicitud === 'Pendiente de pago' ? '' :      string().required('Obligatorio') : ''),
        "Nacionalidad": (isGrid === 3 ? valorEstadoSolicitud === 'Prospecto' || valorEstadoSolicitud === 'Pendiente de pago' ? '' : string().required('Obligatorio') : ''),
        "E_Direcc": (isGrid === 3 ? valorEstadoSolicitud === 'Prospecto' || valorEstadoSolicitud === 'Pendiente de pago' ? '' :     string().required('Obligatorio') : ''),
        "E_Depto": (isGrid === 3 ? valorEstadoSolicitud === 'Prospecto' || valorEstadoSolicitud === 'Pendiente de pago' ? '' :      string().required('Obligatorio') : ''),
        "E_Muni": (isGrid === 3 ? valorEstadoSolicitud === 'Prospecto' || valorEstadoSolicitud === 'Pendiente de pago' ? '' :       string().required('Obligatorio') : ''),
        "EmailE": string().email('Ingrese un correo válido').required('Obligatorio'),
        "FotoN": imageSchema()

    });



    const formikProps = useFormik({
        initialValues,
        validationSchema,
    })


    //Lllenados datos con estados
    useEffect(() => {

        setCarnetValidado(isGrid) // 2 nuevo 1 grid solicitudes , estaba 2,1,1
        if (haySolicitudSeleccionada && datosFormNuevo.hayData) { //no solo mostrarlo, jalar toda la data
            setGridSolicitud(()=>2)//nuevo
            //setIsGrid(1)
        }
        if (!haySolicitudSeleccionada && datosFormNuevo.hayData) {
            setGridSolicitud(()=>1)//grid solicitudes
            //setIsGrid(1)
        }
        if (haySolicitudSeleccionada && !datosFormNuevo.hayData) {
            setGridSolicitud(()=>1)//grid solicitudes
            //setIsGrid(1)
        }


        const datosEmails = async () => {

            await handleSolicitudesEmail(formikProps.values, formikProps.setFieldValue)

            if (props.EmailE !== '') {
                setIsGrid(gridSolicitud)
            }

        }
        if (props.Email !== '' && props.Dpi !== '' && props.valido === 1) {
            datosEmails()
        }

        consultarPlanes()
    }, [gridSolicitud])//gridSolicitud


    const handleSolicitudesEmail = async (values, setFieldValue) => {
        //setar los valores del form

        if (values.Email === "") {
            setModal({
                msg: "Debes ingresar email, para continuar",
                ok: false,
                show: true,
            });
        } else {
        }
        if (values.Dpi === "") {
            setModal({
                msg: "Debes ingresar número de DPI, para continuar",
                ok: false,
                show: true,
            });
        } else {
            setDpiEncargado(()=>values.Dpi);
        }

        if (values.Dpi !== "" && values.Email !== "") {
            setLoading(true);
            const res = await fetchApi({
                url: props.url + "/utils/busquedas",
                headers: props.headers,
                content: {
                    opcion: "SOLICITUDES_EMAIL",
                    emailtutor: values.Email,
                },
            });

            setData(()=>res); //se recibe la informacion completa de la api
            setInscripcionValues(()=>res);
            setLoading(false);
            setFieldValue("EmailE", values.Email);
            if (res.length > 0) {//&& !haySolicitudSeleccionada
                setIsGrid(1);  //grid solicitudes
            } else {
                setIsGrid(2);  // inputs de nuevo registro
            }
        }
    };

    function formatearFechaNacimiento(fecha) {
        if (fecha !== undefined) {
            let dia = fecha.substring(0, 2);
            let mes = fecha.substring(3, 5);
            let anio = fecha.substring(6, 10);
            let fechasinformato = `${anio}-${mes}-${dia}`;

            return fechasinformato;
        }
    }

    const closeAdmisionEdicion = () => {
        //console.log('GRID: ', isGrid)
        setIsGrid(()=>1);
        handleDatosFormNuevo('', '', '', '', '', '', '', '', false)
    };
    const handleBotonProveniente = (comando) => {
        setBotonProveniente(comando);
    }
    const handleEdit = (values, setFieldValue, solicitud) => {
        handleIdSeleccionado(true)
        setDatosSolicitud(()=>solicitud);
        setIsGrid(()=>3);
        handleDatosFormNuevo('', '', '', '', '', '', '', '', false)
    };

    // const handleValidaFechaNac = async (IdGrado, FNacimiento) => {
    //     // setLoading(true);
    //     const resFnace = await fetchApi({
    //         method: "GET",
    //         url: props.url + "/inscripciones/validafechanace",
    //         headers: props.headers,
    //         content: {
    //             FNacimiento,
    //             IdGrado
    //         },
    //     });
    //     // setLoading(false);
    //     console.log(resFnace.msg[0])
    //     return resFnace.msg[0].estado
    // }

    const [alumnoSeleccionado, setAlumnoSeleccionado] = useState()

   const getIdData = async(id) => {
    const resSol = await fetchApi({
        url: props.url + "/utils/busquedas",
        headers: props.headers,
        content: {
            opcion: "ASPIRANTESGRAL_ID",
            IdSolicitud: id,
        },
    });
    
   }

    
    const handleSubmit = async (values, setFieldValue, crearAdmision, idSoli, carnet, editarAdmision, edicionCompleta, estado) => {
        //console.log("EJECUTANDO....",values)
        //getIdData(idSoli)
        const resSol = await fetchApi({
            url: props.url + "/utils/busquedas",
            headers: props.headers,
            content: {
                opcion: "ASPIRANTESGRAL_ID",
                IdSolicitud: idSoli,
            },
        });
        await setEstadoAlumno(()=>estado)
        await handleIdSeleccionado(true)
        await handleDatosFormNuevo('', '', '', '', '', '', '', '', false)
        //setFieldValue("FotoN", "")

        await obtenerCarnetEstudiante(carnet);
        console.log(values)
        console.log(values.Cel)
        values.Cel = values.Cel ? values.Cel.toString():undefined;
        values.Celular = values.Celular? values.Celular.toString():undefined;
        values.E_Edad = values.E_Edad? values.E_Edad.toString():undefined;
        values.E_Edad = values.E_Edad? values.E_Edad.toString():undefined;
        values.E_Telcasa = values.E_Telcasa? values.E_Telcasa.toString():undefined;
        /*
        if (values.Celular !== undefined) {
            values.Celular = values.Celular.toString();
        }
        */

        if (values.FechaNac.includes("-")) {
            values.FechaNac = values.FechaNac.split("-").join("");
            values.FechaNace = values.FechaNace.split("-").join("");
        }

        //console.log(values)
        //console.log(values.FechaNace , values.FechaNac)
        setLoading(true);

        console.log('values: ', values)
        console.log(values.FechaNace)
        console.log(values.FechaNac)
        const resFnace = await fetchApi({
            method: "GET",
            url: props.url + "/inscripciones/validafechanace",
            headers: props.headers,
            content: {
   
    FNacimiento: (crearAdmision ? values.FechaNace : values.FechaNac || formatearFechaASinDiagonales(resSol[0].fechanacimiento)), //año mes dia sin diagonales
                IdGrado: values.IdGrado
            },
        });

        setLoading(false);
        //console.log(resFnace.msg[0])
        if (resFnace?.msg[0].estado === 0) {
            //console.log("igual a cero")
            setModal({
                msg: resFnace.msg[0].mensaje,
                ok: false,
                show: true,
            });
            if (crearAdmision) {
                setIsGrid(2)
            }
            if (editarAdmision) {
                setFieldValue("FechaNac", formatearFechaNacimiento(values.FechaNac));
                setFieldValue("FechaNace", formatearFechaNacimiento(values.FechaNace));
                setIsGrid(3)
            }
        } else {
           // console.log("else igual a cero")
            if (crearAdmision) {
                handleSeleccionado(false)
                let objeto = {
                    Carrera: datosInscripcion.IdCarrera,
                    Grado: datosInscripcion.IdGrado,
                    Sede: datosInscripcion.IdSede,
                    Plan: datosInscripcion.IdPlan,
                }
//                sendPlanes(objeto)
                values.IdSolicitud = "";
                values.idSoli = "";
                values.E_DPI = dpiEncargado;
                values.Cel = values.Cel;
                values.E_Nombres = values.NombresE;
                values.E_Apellidos = values.ApellidosE;
                values.FechaNac = values.FechaNace;
                values.E_EmailE = values.EmailE;
                setLoading(true);
                const res = await fetchApi({
                    method: "POST",
                    url: props.url + "/inscripciones/solicitud",
                    headers: props.headers,
                    content: { ...values },
                });
                 
                
                if(res.msg[0].Error){ // si tiene error, lanza el mensaje
                    setModal({
                        ok:false,
                        msg: res.msg[0].Mensaje,
                        show:true,
                    })
                    
                    //setIsGrid(1)
                    setLoading(false);
                }else{
                    setIsGrid(2)
                    sendPlanes(objeto)
                    idSoli = res.msg[0].IdSolicitud;
                    enviarFoto(values.FotoN, idSoli)
                    carnet = res.msg[0].Carnet;
                    obtenerCarnet(res.msg[0].Carnet)
                    setLoading(false);
                    console.log('valor')

                    ///
                    props.Dpi = dpiEncargado;
                    props.paso = 2;
                    props.form = 3;
                    props.valido = 1;
                    props.Email = values.Email;
                    props.carnet = carnet;
                    props.IdSoli = idSoli;
                    props.Nombres = values.Nombres;
                    props.Apellidos = values.Apellidos;
                    props.ColAnterior = values.ColAnterior;
                    props.Genero = values.Genero;
                    props.EmailE = values.EmailE;
                    props.encargado = values.encargado;
                    props.Cel = values.Cel;
        
                    Validar(props); // Método pasado del AdmisionesIndex
                    ///
                }
            }else{
                console.log('seleccionado: ', props)

                                ///
                                props.Dpi = resSol[0].E_DPI;
                                props.paso = 2;
                                props.form = 3;
                                props.valido = 1;
                                props.Email = resSol[0].Email;
                                props.carnet = resSol[0].Carnet;
                                props.IdSoli = idSoli;
                                props.Nombres = resSol[0].NombreAlumno;
                                props.Apellidos = resSol[0].apellidoalumno;
                                props.ColAnterior = values.ColAnterior;
                                props.Genero = values.Genero;
                                props.EmailE = resSol[0].Email;
                                props.encargado = resSol[0].encargado;
                                props.Cel = resSol[0].Cel;
                    
                                Validar(props); // Método pasado del AdmisionesIndex
            }

            if (editarAdmision) {
                setLoading(true);
                handleSeleccionado(true)

                let objeto = {
                    Carrera: (datosInscripcion.Carrera === undefined ? datosInscripcionStep1.Carrera : datosInscripcion.Carrera),
                    Grado: (datosInscripcion.Grado === undefined ? datosInscripcionStep1.Grado : datosInscripcion.Grado),
                    Sede: (datosInscripcion.Sede === undefined ? datosInscripcionStep1.Sede : datosInscripcion.Sede),
                    Plan: (datosInscripcion.Plan === undefined ? datosInscripcionStep1.Plan : datosInscripcion.Plan),
                }
                sendPlanes(objeto)
                if (values.Cel !== undefined) {
                    values.Cel = values.Cel.toString();
                }
                if (values.Celular !== undefined) {
                    values.Celular = values.Celular.toString();
                }

                values.E_EmailE = values.Email;
                values.Nombres = datosSolicitud.Nombres;
                values.Apellidos = datosSolicitud.Apellidos;

                const res = await fetchApi({
                    method: "POST",
                    url: props.url + "/inscripciones/solicitud",
                    headers: props.headers,
                    content: { ...values },
                });

                //solicitud completa

                const res2 = await fetchApi({
                    method: "POST",
                    url: props.url + "/inscripciones/actualizasolicitud",
                    headers: props.headers,
                    content: { ...values },
                });
                // fin de  solicitud completa
                setLoading(false);

                ///
                props.Dpi = dpiEncargado;
                props.paso = 2;
                props.form = 3;
                props.valido = 1;
                props.Email = values.Email;
                props.carnet = carnet;
                props.IdSoli = idSoli;
                props.Nombres = values.Nombres;
                props.Apellidos = values.Apellidos;
                props.ColAnterior = values.ColAnterior;
                props.Genero = values.Genero;
                props.EmailE = values.EmailE;
                props.encargado = values.encargado;
                props.Cel = values.Cel;
    
                Validar(props); // Método pasado del AdmisionesIndex
                ///
            }

            
        }
    };

    const handleAtras = (values, comando) => {

        if (isGrid === 3 && haySolicitudSeleccionada) {
            //borrado del contenido de form 2 grid 1 para que no tome los values de editar
            handleDatosFormNuevo('', '', '', '', '', '', '', '', false)
            values.ColAnterior = ''
            values.Cel = ''
            formikProps.setFieldValue('ColAnterior', '')
            formikProps.setFieldValue('Cel', '')
        }
        if (comando === 'atras') {
            handleIdSeleccionado(true)
        }
        if (comando === 'nuevo') {
            setEsNuevo(true)
            handleDatosFormNuevo('', '', '', '', '', '', '', '', false)
            values.ColAnterior = ''
            values.Cel = ''
            values.Nombres = ''
            values.Genero = ''
            values.FechaNace = ''
            values.Apellidos = ''
            values.ApellidosE = ''
            values.NombresE = ''
        }

        if (haySolicitudSeleccionada) {
            handleDatosFormNuevo(values.Apellidos, values.Nombres, values.ApellidosE, values.NombresE, values.ColAnterior, values.Cel, values.Genero, values.FechaNace, true)
        }
        props.form = 1
        props.valido = 1
        props.paso = 1
        props.Dpi = dpiEncargado || values.Dpi
        props.Email = values.Email
        props.Nombres = values.Nombres
        props.Apellidos = values.Apellidos
        props.FechaNace = values.FechaNace
        props.ColAnterior = values.ColAnterior
        props.Genero = values.Genero
        props.encargado = values.encargado
        props.EmailE = values.EmailE
        props.Cel = values.Cel
        Validar(props) // Método pasado del AdmisionesIndex
    }

    const handleFecha = (valor) => {
        setFechaSinFormato(valor)
    }

    useEffect(() => {
        console.log(botonProveniente)
        //handleAceptar()
    }, [botonProveniente])




    const enviarFoto = async (foton, idsoli) => {
        const res = await fetchApi({
            method: 'POST',
            url: props.url + "/inscripciones/subirfoto",
            headers: props.headers,
            content: {
                "IdSolicitud": idsoli,
                "FotoN": foton
            }
        });
    }

    const enviarFotoActualizacion = async (foton, idsoli) => {
        const { FotoN } = foton
        const res = await fetchApi({
            method: 'POST',
            url: props.url + "/inscripciones/subirfoto",
            headers: props.headers,
            content: {
                "IdSolicitud": idsoli,
                "FotoN": FotoN
            }
        });
    }

    const handleAceptar = (...propiedades) => {
        //setFieldValue("FotoN", "")
        let valoresForm = propiedades
        console.log('propiedades: ', propiedades)
        console.log('botonProveniente: ', botonProveniente)
        if (isGrid === 1) {

            if (botonProveniente === 'NUEVA SOLICITUD') {
                setIsGrid(2)
                handleDatosFormNuevo('', '', '', '', '', '', '', '', false)
                props.FechaNace = ''
                // lineas para regresar al paso 1
                props.form = 1
                Validar(props)
            }

            if (botonProveniente === 'BUSCAR') {

                //handleDatosFormNuevo( propiedades[0].Apellidos, propiedades[0].Nombres, propiedades[0].ApellidosE, propiedades[0].NombresE, propiedades[0].ColAnterior, propiedades[0].Cel, propiedades[0].Genero, propiedades[0].FechaNace, true )
            }
        }
        // guardar el nuevo ingreso
        if (isGrid === 2) {

            if (botonProveniente === 'GUARDAR') {
                console.log('propiedades: ', propiedades[0], propiedades[1])
                handleSubmit(
                    propiedades[0], // values
                    propiedades[1], // funciones de formik
                    true,
                    '',
                    '',
                    false,
                    false,
                    'Prospecto'
                );

            }
        }
        // al editar los datos
        if (isGrid === 3) {

            //const handleSubmit = async ( values, setFieldValue, crearAdmision, idSoli, carnet, editarAdmision ) => {
            handleSubmit(
                propiedades[0],
                propiedades[1],
                false,
                datosSolicitud.Id,
                datosSolicitud.Carnet,
                true,
                false
                //true
            );

            enviarFotoActualizacion(propiedades[0], datosSolicitud.Id)
        }
    }



    const obtenerNombreDelPlan = (idDelPlan) => {

        let nombre = todosPlanes.filter((plan) =>
            plan.IdPlan === idDelPlan
        );
        return nombre[0]?.NombrePlan;
    };

    const handleVentanaGrados = (datos) => {
        let objeto = {
            Carrera: datos.Carrera,
            Grado: datos.Grado,
            Sede: datos.Sede,
            Plan: obtenerNombreDelPlan(datos.IdPlan),
        }
        sendPlanes(objeto)
    }

    const llenarGrid = async (email, id, fecha) => {

        const res = await fetchApi({
            url: props.url + "/utils/busquedas",
            headers: props.headers,
            content: {
                opcion: "SOLICITUDES_EMAIL",
                emailtutor: email,
            },
        });
        const solicitud = res.filter(elemento => elemento.Id === id && elemento.FNacimiento === fecha)

        setData(solicitud); //se recibe la informacion completa de la api
        setInscripcionValues(solicitud);
        setLoading(false);

        //setFieldValue("EmailE", values.Email);
        setIsGrid(1);  // inputs de nuevo registro
        /*
        if (res.length > 0 ) {//&& !haySolicitudSeleccionada
            setIsGrid(1);  //grid solicitudes
        } else {
            setIsGrid(2);  // inputs de nuevo registro
        }
        */
    }

    const getDataParametros = async (id, nacimiento) => {
        const fechaFormateada = formatearFechaDiagonalesDDMMYY(nacimiento)
        const resSol = await fetchApi({
            url: props.url + "/utils/busquedas",
            headers: props.headers,
            content: {
                opcion: "ASPIRANTESGRAL_ID",
                IdSolicitud: id,
            },
        });
        formikProps.initialValues.Email = resSol[0].Email
        formikProps.initialValues.Dpi = resSol[0].E_DPI
        setIdsRuta({
            IdSede: resSol[0].IdSede,
            IdGrado: resSol[0].IdGrado
        })
        setRutaAlt('../../img/loader.gif')
        // setDatosInscripcion
        if (bloqueador === 0) {
            llenarGrid(resSol[0].Email, id, fechaFormateada)
            setBloqueador(1)
        }
    }
    /*
        const handleAtrasRuta = () => {
            navigate('/campus/busquedasolicitud')
    
        }
        */


        const mostrarMensaje = () => {
            setModal({
                msg:"Ingrese todos los datos por favor",
                ok:false,
                show:true,
            })
            /*
            setModal({
                msg: "Debes ingresar email, para continuar",
                ok: false,
                show: true,
            });
            */
        }
        const comprobar = (values, errors) => {
            
            if (values.Email === "" || values.Dpi === "" || Object.entries(errors).length !== 0){
                //mostrarMensaje()
                return false
            }else{
                return true
            }

        }

    useEffect(() => {
        //console.log('INFORMACION: ', parametrosRuta.idSolicitud, esNuevo)
        if (!esNuevo && parametrosRuta.idSolicitud) {
            getDataParametros(parametrosRuta.idSolicitud, parametrosRuta.fechaNacimiento)
        } else {
            setIsGrid(2)
        }
    }, [parametrosRuta?.idSolicitud, esNuevo])

    return (
        <>
            <WarningModal
                open={loading ? true : false}
                image={<img src={rutaAlt} alt='loading' />}
                opacity='bg-opacity-100'
            />

            <Formik
                initialValues={initialValues}
                onSubmit={(values, setFieldValue, errors) => handleAceptar(values, setFieldValue, false, '', '', false, false, errors)}
                validationSchema={validationSchema}
            >
                {({ setFieldValue, values, resetForm, errors }) => {
                   // console.log('errors:', errors)
                    //console.log('values:', values)
                    return (
                        <Form>
                            <WarningModal
                                open={modal.show ? true : false}
                                image={
                                    modal.ok
                                        ? <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
                                        : <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto" />
                                }
                                title='Aviso'
                                subtitle={<span>{modal.msg}</span>}
                                opacity='bg-opacity-50'
                            >
                                <div className="mt-5 sm:mt-6 ">
                                    <button
                                        onClick={() => {
                                            if (modal.reload) {
                                                window.location.reload()
                                            }
                                            setModal(curr => ({
                                                ...curr, show: false, reload: false
                                            }))
                                        }}
                                        type="button"
                                        className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
                                    >
                                        Entendido
                                    </button>
                                </div>
                            </WarningModal>
                            <div className="bg-primarioMira px-4 py-5 shadow rounded-lg sm:p-6 animate-fade-in"
                                data-te-animation-init
                                data-te-animation-reset="true"
                                data-te-animation="[slide-right_1s_ease-in-out]"
                            >
                                <div className="lg:grid lg:grid-cols-6 lg:gap-6">
                                    <div className="mt-5 lg:col-span-3 lg:mt-0">
                                        <div className="px-4 py-4 grid grid-cols-4 gap-6 rounded-lg bg-secundarioMira">

                                            <div className="col-span-4 sm:col-start-1 lg:col-end-3">
                                                {/* <label className="block text-sm font-medium text-white">Selecciona el campus al que deseas inscribirte</label> */}
                                                <Label lbl="Correo electrónico" field="Email" />
                                                <Field
                                                    //disabled={bloquear}
                                                    type="email"
                                                    name='Email'
                                                    //onChange={(e) => handleData(e)}
                                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm">
                                                </Field>
                                                {errors?.Email && (
                                               <div className="ml-4 text-sm font-medium text-secundario">
                                                 {errors?.Email}
                                               </div>)}
                                            </div>

                                            <div className="col-span-4 lg:col-start-3 lg:col-end-5">
                                                <Label lbl="DPI" field="Dpi" />
                                                <Field
                                                    //disabled={bloquear}
                                                    type='text'
                                                    name='Dpi'
                                                    onBlur={(e) => handleDpiBlur(e, setModal, setIsGrid, contadorDPI, setContadorDPI, props.url2, props.headers)}
                                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm">
                                                </Field>
                                                {errors?.Dpi && (
                                               <div className="ml-4 text-sm font-medium text-secundario">
                                                 {errors?.Dpi}
                                               </div>)}
                                            </div>

                                        </div>
                                    </div>

                                    <div className="xl:py-12 col-span-full lg:col-start-4 lg:col-end-4 row-start-1">
                                        <button
                                            ref={buscarRef}
                                            onClick={() => { handleSolicitudesEmail(values, setFieldValue); setBotonProveniente('BUSCAR') }}
                                            //type="submit"
                                            className="relative inline-flex justify-center rounded-md border border-transparent bg-azulBrillanteMira py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-azulLogos hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                                        >
                                            <div className="flex">
                                                <MagnifyingGlassIcon className="h-5 w-5 text-white" aria-hidden="true" />
                                                <p className="ml-1">Crear o buscar solicitud</p>
                                            </div>
                                        </button>
                                    </div>
                                    {/* Termina pasos Sidebar */}
                                </div>
                                {(isGrid === 1) ? (

                                    <div className="lg:grid sm:flex grid-cols-6 gap-6 md:overflow-hidden sm:overflow-scroll md:block ">
                                        <div className="px-2 py-2 col-span-full lg:col-start-1 lg:col-end-6 rounded-lg bg-secundarioMira">
                                            <AdmisionesGridSoli
                                                solicitudes={data}
                                                handleSubmit={handleSubmit}
                                                handleEdit={handleEdit}
                                                values={values}
                                                setFieldValue={setFieldValue}
                                                setGrid={setIsGrid}
                                                handleIdSeleccionado={handleIdSeleccionado}
                                                handleBotonProveniente={handleBotonProveniente}
                                                handleVentanaGrados={handleVentanaGrados}
                                                handleSeleccionado={handleSeleccionado}
                                                parametrosRuta={parametrosRuta}
                                            />
                                        </div>
                                    </div>) : (isGrid === 2) ? (
                                        <>
                                            {/*condicionar para mostrar*/}
                                            <AdminDatosNuevo
                                                setFieldValue={setFieldValue}
                                                errors={errors}
                                                values={values}
                                                onAction={handleFecha}
                                                FechaNace={props.FechaNace}
                                                FechaSinFormato={fechaSinFormato}
                                                datosFormNuevo={datosFormNuevo}
                                                formatearFechaNacimiento={formatearFechaNacimiento}
                                                inscripcionValues={inscripcionValues}
                                                //datosInscripcion={datosInscripcion}
                                                Carnetvalidado={carnetValidado}
                                                datosInscripcionStep1={datosInscripcionStep1}
                                            />
                                        </>) : (isGrid === 3) ? (
                                            <>
                                                <AdmisionEdicion
                                                    closeAdmisionEdicion={closeAdmisionEdicion}
                                                    todosPlanes={todosPlanes}
                                                    datosSolicitud={inscripcionValues}
                                                    solicitudSeleccionada={datosSolicitud}
                                                    datosPasos={props.datosPasos}
                                                    url={props.url}
                                                    headers={props.headers}
                                                    handleSubmit={handleSubmit}
                                                    setFieldValue={setFieldValue}
                                                    handleSolicitudesEmail={handleSolicitudesEmail}
                                                    props={props}
                                                    values={values}
                                                    errors={errors}
                                                    //getDataSeleccionado={getDataSeleccionado}
                                                    formatearFechaNacimiento={formatearFechaNacimiento}
                                                    isValid={formikProps.isValid}
                                                    handleEstadoSolicitud={handleEstadoSolicitud}
                                                    handleDatosFormNuevo={handleDatosFormNuevo}
                                                    datosFormNuevo={datosFormNuevo}
                                                    //isGrid={isGrid}
                                                    datosInscripcion={datosInscripcion}
                                                    obtenerDatosInscripcion={obtenerDatosInscripcion}
                                                    datosInscripcionStep1={datosInscripcionStep1}
                                                    setBotonProveniente={setBotonProveniente}
                                                    enviarFotoActualizacion={enviarFotoActualizacion}
                                                    setDatosGradoParametro={setDatosGradoParametro}
                                                    sendPlanes={sendPlanes}
                                                />
                                            </>) :
                                    null
                                }
                                <div className="grid grid-cols-6 gap-6">
                                    <div className="col-span-full lg:col-start-1 lg:col-end-2 row-start-1">

                                        <button
                                            type="button"
                                            className="relative inline-flex justify-center rounded-md border border-transparent bg-azulBrillanteMira py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-azulLogos hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                                            onClick={() => handleAtras(values, "atras")}
                                        >
                                            <div className="flex">
                                                <ArrowLeftIcon className="h-5 w-5 text-white" aria-hidden="true" />
                                            </div>
                                            <p className="ml-1">Atrás</p>
                                        </button>

                                        {/* 
                                        <button
                                        onClick={()=>(handleAtrasRuta())}
                                        >RUTA ANTERIOR</button>
                                        */}
                                    </div>
                                    {(isGrid === 2) ? (
                                        <div className="lg:col-span-full lg:col-start-4 lg:col-end-4 row-start-1">
                                            <button
                                                type="submit"
                                                onClick={ comprobar(values, errors) ? () => { setBotonProveniente('GUARDAR'); handleAceptar(); }: mostrarMensaje}
                                                className="relative inline-flex justify-center rounded-md border border-transparent bg-azulBrillanteMira py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-azulLogos hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                                            >
                                                <div className="flex">
                                                    <ArrowRightIcon className="h-5 w-5 text-white" aria-hidden="true" />
                                                    <p className="ml-1">Aceptar</p>
                                                </div>
                                            </button>
                                        </div>) : (isGrid === 1) ? (
                                            <div className="col-span-full lg:col-start-4 lg:col-end-4 row-start-1">
                                                <button
                                                    onClick={() => handleAtras(values, "nuevo")}
                                                    //onClick={() => {setBotonProveniente('NUEVA SOLICITUD');handleAceptar(setFieldValue)}}
                                                    className="relative inline-flex justify-center rounded-md border border-transparent bg-azulBrillanteMira py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-azulLogos hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                                                >
                                                    <div className="flex">
                                                        <PlusCircleIcon className="h-5 w-5 text-white" aria-hidden="true" />
                                                        <p className="ml-1">Agregar otro aspirante</p>
                                                    </div>
                                                </button>
                                            </div>) : null
                                    }
                                </div>
                            </div>
                        </Form>
                    );
                }}
            </Formik>


        </>
    )
}

export default AdminStep2